import { css } from '@emotion/react'

import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        root: custom.dashBoardRoot,
        main: css`
          width: 100%;
        `,
    }
}

export default styles
